/**
 * Pendo event names for Ad Spaces. Prefixed so they never collide with the
 * retired AdKit events in Pendo, which are keyed by name. Tracked at the call
 * site after the request succeeds: one endpoint serves several actions here
 * (updateAdKit is rename, timing and restore), so a middleware keyed by
 * endpoint couldn't tell them apart.
 */
export enum AdSpacesEvents {
  // Views
  VIEW_DASHBOARD = "Ad Spaces - View Dashboard",
  VIEW_FIRST_VISIT = "Ad Spaces - View First Visit",
  VIEW_CAMPAIGN = "Ad Spaces - View Campaign",
  VIEW_NEW_CAMPAIGN_STEP = "Ad Spaces - View New Campaign Step",
  VIEW_EDIT_CAMPAIGN_STEP = "Ad Spaces - View Edit Campaign Step",
  VIEW_IMAGE_LIBRARY = "Ad Spaces - View Image Library",
  OPEN_GO_LIVE = "Ad Spaces - Open Go Live",

  // Campaigns
  CREATE_CAMPAIGN = "Ad Spaces - Create Campaign",
  EDIT_CAMPAIGN = "Ad Spaces - Edit Campaign",
  UPDATE_CAMPAIGN_SETTINGS = "Ad Spaces - Update Campaign Settings",
  UPDATE_HOLE_LOAD_TIMING = "Ad Spaces - Update Hole Load Timing",
  ARCHIVE_CAMPAIGN = "Ad Spaces - Archive Campaign",
  RESTORE_CAMPAIGN = "Ad Spaces - Restore Campaign",

  // Simulators
  GO_LIVE = "Ad Spaces - Go Live",
  PUSH_UPDATE = "Ad Spaces - Push Update",
  TAKE_DOWN = "Ad Spaces - Take Down",

  // Image Library
  UPLOAD_IMAGE = "Ad Spaces - Upload Image",
  CROP_IMAGE = "Ad Spaces - Crop Image",
  REPLACE_IMAGE = "Ad Spaces - Replace Image",
  UPDATE_IMAGE_DETAILS = "Ad Spaces - Update Image Details",
  DELETE_IMAGE = "Ad Spaces - Delete Image",
  RESTORE_IMAGE = "Ad Spaces - Restore Image",
}
